import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';


import { SiteLogoComponent } from './svg/site-logo/site-logo.component';


import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { ProfileIconComponent } from './svg/profile-icon/profile-icon.component';
import { PostalMarketComponent } from './svg/postal-market/postal-market.component';
import { OwnMarkComponent } from './svg/brand-icons/own-mark/own-mark.component';


import { AngularFontAwesomeModule } from 'angular-font-awesome';
import {NgxLeafletFullscreenModule} from '@runette/ngx-leaflet-fullscreen'
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { MapPageComponent } from './components/map-page/map-page.component';
import { MapContainerComponent } from './components/map-container/map-container.component';
import { SearchRowComponent } from './components/search-row/search-row.component';
import { FilterCheckboxBlockComponent } from './components/filter-checkbox-block/filter-checkbox-block.component';
import { FiltersListToggleComponent } from './components/filters-list-toggle/filters-list-toggle.component';
import { SearchInputGroupComponent } from './components/search-input-group/search-input-group.component';

import { MayScheduleInfo } from './components/may-schedule-info/may-schedule-info.component';

import { SelectedFiltersAsTagsComponent } from './components/selected-filters-as-tags/selected-filters-as-tags.component';
import { MapPreviewContainerComponent } from './components/map-preview-container/map-preview-container.component';
import { SiteLogoWinterComponent } from './svg/site-logo-winter/site-logo-winter.component';

import { ModalModule } from 'ngx-bootstrap/modal';
import { FilterRadioBlockComponent } from './components/filter-radio-block/filter-radio-block.component';


const appRoutes: Routes = [

  { path: '', component: MapPageComponent }, // component: FindPostIndexComponent }   redirectTo: 'find-post-index'

];


@NgModule({
  declarations: [
    AppComponent,
    SiteLogoComponent,
    HeaderComponent,
    FooterComponent,
    ProfileIconComponent,
    PostalMarketComponent,
    OwnMarkComponent,
    MobileMenuComponent,
    MapPageComponent,
    MapContainerComponent,
    SearchRowComponent,
    FilterCheckboxBlockComponent,
    FiltersListToggleComponent,
    SearchInputGroupComponent,
    SelectedFiltersAsTagsComponent,
    MapPreviewContainerComponent,
    SiteLogoWinterComponent,
    MayScheduleInfo,
    FilterRadioBlockComponent
  ],
  imports: [
    ModalModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AngularFontAwesomeModule,
    LeafletModule,
    RouterModule.forRoot(appRoutes, { useHash: false }), // , {useHash: true}    , enableTracing: true
    NgxLeafletFullscreenModule,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
